import React, { useEffect, useRef } from "react";
import { useAdblockDetector } from "react-adblock-detector";

const AdBlockDetector = () => {
  const [isAdblockCheckComplete, isAdblockerDetected] = useAdblockDetector();

  useEffect(() => {
    if (isAdblockCheckComplete) {
      window.dataLayer.push({
        event: "adBlockDetected",
        isActive: isAdblockerDetected,
      });
    }
  }, [isAdblockCheckComplete]);
  return null;
};
export default AdBlockDetector;
